import {
  Box,
  Button,
  Container,
  Heading,
  Link,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { ReactNode, useEffect, useState } from "react";

import { AccordionSection } from "./AccordionSection";

import { eventsQuery } from "../../../queries/events";

type ProgramsProps = {
  title: string;
};

export const Programs: React.FC<ProgramsProps> = ({ title }) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const [isRightContentOpen, setIsRightContentOpen] = useState(false);
  const [areStatsVisible, setAreStatsVisible] = useState(false);
  const [showEventContent, setShowEventContent] = useState(false);
  const [events, setEvents] = useState([]);

  const handleAccordionToggle = (section: string) => {
    setIsAccordionOpen(!isAccordionOpen);
    setIsRightContentOpen(!isRightContentOpen);
    setAreStatsVisible(!areStatsVisible);

    if (section === "events") {
      setShowEventContent(!showEventContent);
      setAreStatsVisible(false);
    } else {
      setShowEventContent(false);
    }
  };

  return (
    <>
      <Box as="section" alignItems="flex-start" justifyContent="center">
        <Container
          maxW={{ base: "3xl", md: "7xl" }}
          p={0}
          px={{ base: "4", md: "0" }}
          py={36}
        >
          <Heading
            as="h2"
            textTransform={"uppercase"}
            textAlign={{ base: "center", md: "left" }}
            fontSize="4xl"
            mb={{ base: "0", md: "14" }}
          >
            {title}
          </Heading>
          <Stack
            direction={{ base: "column", lg: "row" }}
            justify="space-between"
            alignItems="flex-start"
            pos="relative"
          >
            <Stack
              direction={"column"}
              justify="space-between"
              alignItems="flex-start"
              pos="relative"
              w="100%"
            >
              <Box w="100%" onClick={() => handleAccordionToggle("programs")}>
                <AccordionSection
                  title="Programs"
                  content={[
                    "These programs and services connect the diverse sectors of Alabama such as business, education, government agencies, and non-profit organizations through face-to-face interactions and meaningful cross-cultural exchange.",
                    "Global Ties Alabama's portfolio includes fee for service customized cultural competency training that is designed to improve communication and collaboration between customers, constituents, and colleagues. GTA is the sister city coordinator for the Cities of Huntsville and Madison, Alabama.",
                    "The international exchange programs GTA hosts include but are not limited to the International Visitor Leadership Program, Open World, Fulbright Visiting Scholars, Youth Ambassador Exchange Programs, Transatlantic Media Network, Mentoring Partnerships for Young African Leaders, Young Leaders of the Americas Initiative.",
                  ]}
                  buttonText="Explore Programs"
                  href="/programs"
                  // isAccordionOpen={isAccordionOpen}
                />
              </Box>
              <Box w="100%" onClick={() => handleAccordionToggle("events")}>
                <AccordionSection
                  title="Events"
                  content={[
                    "The Global Perspectives Institute, initiated in 2009, is a partnership between the International Council Services of AL and University of Alabama in Huntsville’s International Program and Services and was designed to reach a broad audience in Madison County. In 2012, the Global Perspectives Institute expanded to the campuses of the University of North Alabama, the University of Alabama in Birmingham, Oakwood University, and Alabama State University.",
                    "The Global Perspectives Institute is an enrichment forum designed to foster dialogue on topics and issues of international focus. It increases knowledge and understanding, creates international networks, aids in social transformation, and generates new ideas and solutions. The increased interest in language, culture, and opportunity for dialogue allows sponsors, major supporters, and attendees to have an opportunity to meet the featured speakers in a social setting prior to or following the event. Publicity and outreach for these sessions are done using local radio stations, newspapers, council meetings, word of mouth, and social media.",
                  ]}
                  buttonText="Explore Events"
                  href="/events"
                  // isAccordionOpen={isAccordionOpen}
                />
              </Box>
            </Stack>
            <Box w="100%">
              {areStatsVisible && !showEventContent ? (
                <>
                  <SimpleGrid columns={{ base: 1, md: 1 }}>
                    {stats.map((stat) => (
                      <Box key={stat.title}>
                        <Text
                          textTransform={"uppercase"}
                          color="#768178"
                          fontWeight={"700"}
                          fontSize={"xl"}
                          py={4}
                        >
                          {stat.title}
                        </Text>
                        <Text fontSize={"md"} color={"#768178"}>
                          {stat.content}
                        </Text>
                      </Box>
                    ))}
                  </SimpleGrid>
                  {/* <Link href="/programs">
                    <Button
                      bg="transparent"
                      aria-label="view-programs"
                      color="#D9A542"
                      pl={0}
                      fontWeight={"bold"}
                      justifyContent={"flex-start"}
                      textTransform={"uppercase"}
                      _hover={{ bg: "transparent" }}
                    >
                      View all programs
                    </Button>
                  </Link> */}
                </>
              ) : showEventContent ? (
                // @ts-ignore
                <EventList events={events} />
              ) : null}
            </Box>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

const EventList = () => {
  const eventsRight = eventsQuery();
  const uniqueYears = [
    ...new Set(eventsRight.map((item: any) => parseInt(item.dateGmt))),
  ].map((year: any) => year.toString());

  return (
    <>
      <SimpleGrid columns={{ base: 1, md: 1 }}>
        {uniqueYears.map((year) => (
          <Box key={year}>
            <Text
              textTransform="uppercase"
              color="#768178"
              fontWeight="bold"
              fontSize="xl"
              py={4}
            >
              {year}
            </Text>
            {eventsRight
              .filter(
                (event: any) => parseInt(event.dateGmt) === parseInt(year)
              )
              .map((event: any) => (
                <Box
                  display="flex"
                  alignItems={{ base: "flex-start", md: "center" }}
                  justifyContent={"flex-start"}
                  flexFlow={{ base: "column", md: "row" }}
                  key={event.title}
                >
                  <Link
                    href={event.calendarEvents?.viewEventFlyer?.link}
                    fontWeight={400}
                    color={"#49A3CB"}
                  >
                    {event.date} -
                  </Link>
                  <Text
                    textTransform="capitalize"
                    color="#768178"
                    fontWeight="300"
                    fontSize="md"
                    py={2}
                    ml={2}
                  >
                    {event.title}
                  </Text>
                </Box>
              ))}
          </Box>
        ))}
      </SimpleGrid>
      {/* <Link href="/events">
        <Button
          bg="transparent"
          aria-label="view-events"
          color="#D9A542"
          pl={0}
          fontWeight={"bold"}
          justifyContent={"flex-start"}
          textTransform={"uppercase"}
          _hover={{ bg: "transparent" }}
        >
          View all events
        </Button>
      </Link> */}
    </>
  );
};

const StatsText = ({ children }: { children: ReactNode }) => (
  <Text as={"span"} fontWeight={400} color={"#49A3CB"}>
    {children}
  </Text>
);

const stats = [
  {
    title: "Adult Programs",
    content: (
      <>
        <StatsText>
          <Link href="https://eca.state.gov/ivlp" target="_blank">
            International Visitor Leadership Program (IVLP)
          </Link>
        </StatsText>{" "}
        The International Visitor Leadership Program was first launched in 1940.
      </>
    ),
  },
  {
    content: (
      <>
        <StatsText>
          <Link href="https://ytili.org/" target="_blank">
            The Young Transatlantic Innovation Leaders Initiative (YTILI)
          </Link>
        </StatsText>{" "}
        YTILI is a Fellowship Program created by the U.S. Department of State.
      </>
    ),
  },
  {
    content: (
      <>
        <StatsText>
          <Link href="https://www.openworld.gov/" target="_blank">
            Young Leaders of the Americas Initiative (YLAI)
          </Link>
        </StatsText>{" "}
        Launched in 2015, YLAI helps entrepreneurs from Latin America, The
        Caribbean, and Canada engage in an annual fellowship and active online
        networking opportunity.
      </>
    ),
  },
  {
    content: (
      <>
        <StatsText>
          <Link href="https://us.fulbrightonline.org/" target="_blank">
            The Fulbright
          </Link>
        </StatsText>{" "}
        U.S. Scholar Program offers diverse opportunities for U.S. academics,
        and professionals to teach, research, and conduct professional projects
        while attending seminars abroad.
      </>
    ),
  },

  {
    title: "Youth programs",
    content: (
      <>
        <StatsText>
          <Link href="https://www.meridian.org/programs/paylp/" target="_blank">
            Pan Africa Youth Leadership Program (PAYLP)
          </Link>
        </StatsText>{" "}
        The Pan Africa Youth Leadership Program (PAYLP) believes in the
        potential for great & lasting impact when leadership development
        programs target young emerging leaders and adults who empower them.
      </>
    ),
  },
];
